export const PXCopy = (function () {
	'use strict';

	function init() {
		console.log('copy block init');
	}

	return {
		init: init,
	};
})();
